import { TextField, InputLabelProps } from "@mui/material";
import React from "react";

export interface IInput {
  label?: string | any;
  type?: string;
  name?: string;
  value: string | number | undefined;
  classes?: any;
  hasError?: string | boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  InputLabelProps?: InputLabelProps;
  size?: "small" | "medium";
  [key: string]: any;
}

function Input({
  label,
  value,
  type = "text",
  name,
  classes,
  hasError,
  onChange,
  InputLabelProps,
  size = "small",
  ...props
}: IInput) {
  return (
    <TextField
      fullWidth
      size={size}
      variant="outlined"
      type={type}
      label={label}
      name={name}
      className={`${classes}`}
      value={value || ""}
      onChange={onChange}
      error={!!hasError}
      helperText={hasError}
      InputLabelProps={InputLabelProps}
      {...props}
    />
  );
}

export default Input;
